import Image from "next/image";

import { useSidebar } from "@/components/ui/sidebar";
import { SidebarHeader } from "@/components/ui/sidebar";

export default function AppSidebarHeader() {
  const { open } = useSidebar();
  return (
    <SidebarHeader>
      <div className="flex overflow-hidden w-full items-center h-12">
        {!open ? (
          <Image src="/images/winshop-crm-icon.svg" alt="WinShop CRM Logo" width={32} height={32} />
        ) : (
          <Image
            src="/images/winshop-crm-dark.svg"
            alt="WinShop CRM Logo"
            width={128}
            height={32}
          />
        )}
      </div>
    </SidebarHeader>
  );
}
